import { render, staticRenderFns } from "./BaseSpinner.vue?vue&type=template&id=fcd32f8a&"
import script from "./BaseSpinner.vue?vue&type=script&lang=js&"
export * from "./BaseSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcd32f8a')) {
      api.createRecord('fcd32f8a', component.options)
    } else {
      api.reload('fcd32f8a', component.options)
    }
    module.hot.accept("./BaseSpinner.vue?vue&type=template&id=fcd32f8a&", function () {
      api.rerender('fcd32f8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseSpinner.vue"
export default component.exports